var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Path_3",
    "data-name": "Path 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 215.75,
    height: 54.41,
    viewBox: "0 0 215.75 54.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3-2",
    "data-name": "Path 3",
    d: "M324.241,119.532c-17.857,0-27.2-13.684-27.2-27.2s9.343-27.2,27.2-27.2V76.881c-10.672,0-15.449,7.758-15.449,15.449s4.778,15.45,15.449,15.45Zm24.319.008h11.753V88.635H348.56ZM333.614,76.881h41.648V65.13H333.614Zm50.865,42.659h11.753V65.13H384.479Z",
    transform: "translate(-243.438 -65.13)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M95.251,119.54,74.472,65.13H63.159L42.38,119.54H54.131L68.815,81.091,83.5,119.54Z",
    transform: "translate(-42.38 -65.13)",
    fill: "#f1563c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M844.78,65.13,831.737,82.558,818.695,65.13H804.02l27.716,37.045L859.457,65.13Z",
    transform: "translate(-643.707 -65.13)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.2de8775bfabb1716b09d97393d170fcf.svg";
export { ForwardRef as ReactComponent };